import { render, staticRenderFns } from "./DialogRightAlign.vue?vue&type=template&id=951e04c8&scoped=true&"
import script from "./DialogRightAlign.vue?vue&type=script&lang=js&"
export * from "./DialogRightAlign.vue?vue&type=script&lang=js&"
import style0 from "./DialogRightAlign.vue?vue&type=style&index=0&id=951e04c8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "951e04c8",
  null
  
)

export default component.exports